export default {
      id: "icon--leisure-tick-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--leisure-tick-usage",
      toString: function () {
        return this.url;
      }
    }